import type { ReactNode } from "react"
import Card from "@/components/card"
import Tooltip from "@/components/tooltip"
import { useAppSelector } from "@/core/root-reducer"
import { PhysicalRiskScaleItem } from "@/entities/physical-risk/model/physical-risk.types"
import { getGradientColorAt, getPreventionColorAt, getScalePosition, withAlpha } from "@/entities/physical-risk/ui/physical-risk-scale-colors.utils"

export function WizardOverviewField({ label, value }: { label: string; value?: string | null }) {
  if (!value) return null

  return (
    <div>
      <div className="grey-t mb-[2px] text-base">{label}</div>
      <div className="whitespace-pre-line leading-snug">{value}</div>
    </div>
  )
}

export function OverviewCard({ children, lockReason, onClick, title }: {
  children: ReactNode; lockReason?: string; onClick?: () => void; title: string
}) {
  const card = (
    <Card
      className={`mb-0 ${lockReason ? "cursor-default" : onClick ? "_hover" : ""}`}
      style={{ paddingBottom: 30 }}
      onClick={lockReason ? undefined : onClick}>
      <div className="mb-20 text-lg">{title}</div>
      {children}
    </Card>
  )
  return lockReason ? <Tooltip className="w-full" text={lockReason} usePortal>{card}</Tooltip> : card
}

export function SelectedScaleItem({ isPrevention, scale, value }: {
  isPrevention?: boolean; scale: readonly PhysicalRiskScaleItem[]; value: number | null
}) {
  const showCalculations = useAppSelector((state) => state._session.userOptions.risksShowCalculations)
  const item = (scale ?? []).find((scaleItem) => scaleItem.value === value)
  if (!item) return <div className="grey-t">Non renseigné</div>
  const position = getScalePosition(scale, item.value)
  const color = isPrevention ? getPreventionColorAt(position) : getGradientColorAt(position)

  return (
    <div className="flex min-h-[58px] items-center gap-[14px] rounded-[12px] px-20 py-[6px]" style={{ backgroundColor: withAlpha(color, 0.12) }}>
      {showCalculations && (
        <div className="flex h-[46px] w-[46px] shrink-0 items-center justify-center rounded-[12px] text-lg" style={{ backgroundColor: color, color: "white" }}>
          {item.value}
        </div>
      )}
      <div className="min-w-0 leading-snug">
        <div className="font-bold">{item.label}</div>
        {item.description && <div className="grey-t text-sm leading-snug">{item.description}</div>}
      </div>
    </div>
  )
}
